module.exports = "/img/_/_/_/assets/images/creeper/battle/epic//4.jpg?30a41ee691f68d69dee61328ed980747";